import CorporateSponsors from "./CorporateSponsors";

export default CorporateSponsors;
